import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f5baa70a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "share-box" }
const _hoisted_2 = {
  key: 0,
  class: "video-img-box"
}
const _hoisted_3 = { id: "deficiency" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The content has expired", -1))
const _hoisted_5 = {
  key: 1,
  class: "video-img-box"
}
const _hoisted_6 = { id: "deficiency" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "The content is not yet public", -1))
const _hoisted_8 = {
  key: 2,
  class: "video-img-box"
}
const _hoisted_9 = {
  key: 1,
  class: "main-content"
}
const _hoisted_10 = { class: "avatar-text" }
const _hoisted_11 = { class: "nickName" }
const _hoisted_12 = { class: "describe" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, "- Popular content  -", -1))
const _hoisted_14 = { class: "list-box" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 1,
  class: "list-content"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "bottom-text" }, "More wonderful content,Join Kilimall Right Now!", -1))
const _hoisted_18 = {
  key: 3,
  class: "bottom-join"
}
const _hoisted_19 = { class: "bottom-l" }
const _hoisted_20 = ["src"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-content" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Kilimall"),
  /*#__PURE__*/_createElementVNode("p", null, "Affordable Online Shopping")
], -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Join in")

import { ref, reactive, inject, computed, watch } from "vue"
import { useRoute, useRouter } from 'vue-router'
import VideoPlayer from "@/components/video/video.vue"
import { Toast } from 'vant'

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const video = ref<any>();
let safariData = ref({})
let listData = ref([])
/** 如果是苹果端，就不显示下载区域 */
let isShowJoin = ref(true)
const $http: any = inject("$http");
const route = useRoute()
const router = useRouter()
let bridgeURL = ref('')
const app_token = computed(() => {
    return common.getStorage('access_token')
})


// 获取分享详情
const getSafariData = async () => {
    let params = {
        id: route.params.id,
        // is_k: app_token.value.length < 100
    }
    await $http.getSafariSareDetails(params).then((res: any) => {
        console.log(res);
        if (res.code === 200) {
            safariData.value = res.data
            console.log(safariData.value);

        } else {
            Toast.fail({
                message: res.message,
                duration: 5000,
                className: 'tunetable_error_msg_div'
            })
        }

    })
}
// 获取分享列表
const getShareList = async () => {
    let params = {
        // is_k: app_token.value.length < 100
    }
    await $http.getSafariSareList(params).then((res: any) => {
        console.log(res);
        if (res.code === 200) {
            listData.value = res.data
            // console.log(listData.value, 123);

        } else {
            Toast.fail({
                message: res.message,
                duration: 5000,
                className: 'tunetable_error_msg_div'
            })
        }

    })
}

// 操作列表项
const handleListItem = (id: number) => {
    if (window.location.host == '10.0.2.41:8080') {
        bridgeURL.value =
            `http://${window.location.host}/ShareSafari/${id}?sa=Share-Ki-Safari-${id}`
    } else {
        bridgeURL.value =
            `https://${window.location.host}/ShareSafari/${id}?sa=Share-Ki-Safari-${id}`
    }
    window.location.href = bridgeURL.value
    // window.location.href=`http://10.0.2.61:8080/ShareSafari/${id}?sa=Share-Ki-Safari-${id}`
    // router.push({
    //     path: '/ShareSafari/' + id,
    //     query: {
    //         sa: 'Share-Ki-Safari-' + id
    //     },
    // })
}
// 底部join in 
const openApp = () => {
    if (safariData.value.contentsType == 1) {
        console.log('图文');
        window.location.href =
            `https://app.adjust.com/h463n7w?deeplink=kiliapp%3A%2F%2Fkilimall%3Ftype%3D${'64'}%26data%3D${safariData.value.contentsId}%26siteCode%3D${'co'}`;
    } else if (safariData.value.contentsType == 2) {
        console.log('视频');
        window.location.href =
            `https://app.adjust.com/h463n7w?deeplink=kiliapp%3A%2F%2Fkilimall%3Ftype%3D${'63'}%26data%3D${safariData.value.contentsId}%26siteCode%3D${'co'}`;
    }

}
const showJoinIn = () => {
    var sUserAgent: any = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    if (bIsIpad || bIsIphoneOs) {
        isShowJoin.value = false
    }
}
showJoinIn()
watch(() => route.params, (newVal) => {
    if (newVal) {
        console.log(newVal, 11);

        getSafariData()
        getShareList()
    }
}, { immediate: true })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(safariData))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_van_icon, {
              name: "warning",
              size: "0.5rem"
            }),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(safariData)&&_unref(safariData).isPrivate == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_icon, {
              name: "warning",
              size: "0.5rem"
            }),
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true),
    (_unref(safariData) && _unref(safariData).isPrivate != 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (_unref(safariData).contentsType == 1)
            ? (_openBlock(), _createBlock(_component_van_swipe, {
                key: 0,
                class: "main-content",
                autoplay: 3000,
                "indicator-color": "#DD3131"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(safariData).mediaList, (image, index) => {
                    return (_openBlock(), _createBlock(_component_van_swipe_item, { key: index }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("img", null, null, 512), [
                          [_directive_lazy, image.filePath.webpFilters()]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(safariData).contentsType == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(safariData).mediaList, (image, index) => {
                  return (_openBlock(), _createBlock(VideoPlayer, {
                    class: "video-main-box",
                    videoSrc: image.filePath,
                    videoPoster: _unref(safariData).coverImg.webpFilters(),
                    videoAspectRatio: '1:1'
                  }, null, 8, ["videoSrc", "videoPoster"]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(_unref(safariData).contentsType == 2 ? 'user-text-video' : 'user-text-img')
          }, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_van_image, {
                round: "",
                class: "user-avatar",
                fit: "cover",
                src: _unref(safariData).userAvatar
              }, null, 8, ["src"]),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(safariData).nickName), 1)
            ]),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(safariData).contents), 1)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _hoisted_13,
    _createElementVNode("div", _hoisted_14, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listData), (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.contentsId,
          onClick: ($event: any) => (handleListItem(item.contentsId)),
          class: "list-item"
        }, [
          (item.contentsType == 1)
            ? (_openBlock(), _createBlock(_component_van_image, {
                key: 0,
                class: "list-content list-img-box",
                fit: "cover",
                src: item.coverImg.webpFilters()
              }, null, 8, ["src"]))
            : _createCommentVNode("", true),
          (item.contentsType == 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createVNode(_component_van_image, {
                  class: "list-img-box",
                  fit: "cover",
                  src: item.coverImg
                }, null, 8, ["src"]),
                _createVNode(_component_van_image, {
                  class: "icon-play",
                  fit: "cover",
                  src: 'https://image.kilimall.com/kenya/new_wap/goods/ic_play.png'.webpFilters()
                }, null, 8, ["src"])
              ]))
            : _createCommentVNode("", true)
        ], 8, _hoisted_15))
      }), 128))
    ]),
    _hoisted_17,
    (_unref(isShowJoin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              src: 'https://image.kilimall.com/kenya/new_wap/logo/icon_96.png'.webpFilters(),
              alt: "logo",
              class: "logo"
            }, null, 8, _hoisted_20),
            _hoisted_21
          ]),
          _createVNode(_component_van_button, {
            round: "",
            plain: "",
            color: "#979797",
            size: "small",
            type: "primary",
            onClick: openApp
          }, {
            default: _withCtx(() => [
              _hoisted_22
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})